import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="brokerageScale";
export function selectAllPage(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAll(){
  return axios({
    url: `/ws/${moduleName}/selectAll`,
    method: 'get',
  })
}

export function selectOne(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}


export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export function saveItem(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveItem`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}
export function updateItem(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateItem`,
    method: 'put',
    data:parameter
  })
}


export function deleteObj(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function deleteItem(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}/deleteItem`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export default {
  selectAll,
  selectAllPage,
  selectOne,
  update,
  updateItem,
  save:insert,
  saveItem:saveItem,
  delete:deleteObj,
  deleteItem:deleteItem,
}